var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-result',{staticStyle:{"margin-top":"50px"},attrs:{"icon":"error","title":"缺少必要参数","subTitle":""}},[_c('template',{slot:"extra"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }